// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/generate-cube-meta.ts
import type { CubeMeasureEntry, CubeDimensionEntry } from 'shared/src/api/cube-api-types';

export const zohoAccountsCubeMeta = {
  name: 'zoho_accounts',
  title: 'Zoho Accounts',
  measures: {
    'zoho_accounts.count': {
      type: 'number',
      aggType: 'count',
      title: 'Account Count',
      description: 'Number of Zoho accounts',
      meta: {
        category: 'utility',
        supports_rollup: true,
        formula: 'COUNT(*)',
        inputs: [],
        short_description: 'Number of Zoho accounts',
        source_tables: ['media_tool.accounts']
      }
    } as const satisfies CubeMeasureEntry
  },
  dimensions: {
    'zoho_accounts.id': {
      sql: 'id',
      type: 'string',
      title: 'Account ID',
      primaryKey: true,
      meta: {
        short_description: 'Zoho CRM Account ID',
        source_tables: ['media_tool.accounts']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_accounts.name': {
      sql: 'name',
      type: 'string',
      title: 'Account Name',
      meta: {
        short_description: 'Account display name from Zoho CRM',
        source_tables: ['media_tool.accounts']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_accounts.type': {
      sql: 'type',
      type: 'string',
      title: 'Account Type',
      meta: {
        short_description: 'Account type classification (e.g., Direct, Agency)',
        source_tables: ['media_tool.accounts']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_accounts.industry': {
      sql: 'industry',
      type: 'string',
      title: 'Industry',
      meta: {
        short_description: 'Industry vertical of the account',
        source_tables: ['media_tool.accounts']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_accounts.parent_id': {
      sql: 'parent_id',
      type: 'string',
      title: 'Parent Account ID',
      meta: {
        short_description: 'Parent account identifier for account hierarchy',
        source_tables: ['media_tool.accounts']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_accounts.parent_account_name': {
      sql: 'parent_account_name',
      type: 'string',
      title: 'Parent Account Name',
      meta: {
        short_description: 'Display name of the parent account',
        source_tables: ['media_tool.accounts']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_accounts.team_id': {
      sql: 'team_id',
      type: 'string',
      title: 'Team ID',
      meta: {
        short_description: 'Assigned team identifier',
        source_tables: ['media_tool.accounts']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_accounts.team_name': {
      sql: 'team_name',
      type: 'string',
      title: 'Team Name',
      meta: {
        short_description: 'Assigned team display name',
        source_tables: ['media_tool.teams']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_accounts.region': {
      sql: 'region',
      type: 'string',
      title: 'Region',
      meta: {
        short_description: 'Geographic region of the assigned team',
        source_tables: ['media_tool.teams']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_accounts.referral_partner': {
      sql: 'referral_partner',
      type: 'string',
      title: 'Referral Partner',
      meta: {
        short_description: 'Referral partner name',
        source_tables: ['media_tool.accounts']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_accounts.referral_partner_comm': {
      sql: 'referral_partner_comm',
      type: 'number',
      title: 'Referral Partner Commission',
      format: 'currency',
      meta: {
        category: 'financial',
        short_description: 'Referral partner commission amount',
        source_tables: ['media_tool.accounts']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_accounts.referral_commission': {
      sql: 'referral_commission',
      type: 'boolean',
      title: 'Referral Commission',
      meta: {
        short_description: 'Whether referral commission applies to this account',
        source_tables: ['media_tool.accounts']
      }
    } as const satisfies CubeDimensionEntry,
    'zoho_accounts.modified_time': {
      sql: 'modified_time',
      type: 'time',
      title: 'Modified Time',
      meta: {
        short_description: 'Last modified timestamp from Zoho CRM',
        source_tables: ['media_tool.accounts']
      }
    } as const satisfies CubeDimensionEntry
  }
};
